export const TwitterStyleCollections = [
  "skyline",
  "scapes",
  "desolates-metaverse",
];
export const ObjectContainCollections = ["solbees-gen1-cards"];
